export default __webpack_public_path__ + "static/media/spanish.ae5632d0.png";